import DetailedScheduleRow from './DetailedScheduleRow';

export default DetailedScheduleRow;
